import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ClientService {
  constructor(private httpClient: HttpClient) {}

  getData() {
    return this.httpClient.get(environment.Localurl + "client");
  }

  insertData(data) {
    return this.httpClient.post(environment.Localurl + "client", data);
  }

  deleteData(id) {
    return this.httpClient.delete(environment.Localurl + "client/" + id);
  }

  getOneData(id) {
    return this.httpClient.get(environment.Localurl + "client/" + id);
  }

  updateData(id, data) {
    return this.httpClient.put(environment.Localurl + "client/" + id, data);
  }

  getClientByTel(tel) {
    return this.httpClient.get(environment.Localurl + "clientByTel/" + tel);
  }

  getNombreClient() {
    return this.httpClient.get(environment.Localurl + "NombreClient");
  }
}
